export default "__VITE_ASSET__DGgAk87a__"